import i18next from 'i18next';

export const subscription = { id: 'premium', title: i18next.t('Trackman University Subscription', { ns: 'webshop' }), price: 195 };
